import styled from "styled-components";
import { IconButton, FlexContainer, PrimaryButton } from "./styled";
import PlusIcon from "../assets/icons/plus.svg";
import MinusIcon from "../assets/icons/minus.svg";
import { useState, useEffect } from "react";
import NovaIcon from "../assets/images/logo/tokens/nova.png";
import { useDeck } from "../context/DeckContext";
// import ConfirmImage from "../assets/images/confirmImage.png";
// import ProsessingImage from "../assets/images/prosessing.png";
// import ProsessedImage from "../assets/images/prosessed.png";
import { hearthbeat } from "./styled/animations";
import usePaymentTokenBalance from "../hooks/usePaymentTokenBalance";
import useNovaPrice from "../hooks/useNovaPrice";
import { useAccount ,useSwitchChain} from "wagmi";
import { BSC_CHAIN_ID } from "../service/web3/wagmi";
import { createCheckOutTransaction } from "../service/main/api";
import { checkTokenAllowance,approveToken,buyCartWithQuote } from "../service/web3/checkout";
import { MaxUint256 } from "ethers";
import {useLoading} from "../context/LoadingContext";
import { useUserContext } from "../context/UserContext";
import { SLOT_RANGE_PRICES } from "../constants";
import { useToaster } from "../hooks/useToaster";

const BuySlotModalContent = ({ onClose, navigate }) => {
  const { deck } = useDeck();
  const [stage, setStage] = useState("prepare");
  const [amount, setAmount] = useState(1);
  const [cost, setCost] = useState(0);
  const [approved, setApproved] = useState(false);
  const { isLoading, balanceNumber } = usePaymentTokenBalance();
  const {showToaster} = useToaster();
  const {setIsLoading}  = useLoading();
    const { user } = useUserContext();
    const connectedAddress = user?.walletAddress || "";
  const { priceNumber } = useNovaPrice();
      const { chainId: accountChainId } = useAccount();
      const { switchChainAsync, isPending: isSwitching } = useSwitchChain();
    
    useEffect(() => {
      const checkAllowance = async () => {
        if (!connectedAddress) return;
              if (accountChainId !== BSC_CHAIN_ID) {
                try {          await switchChainAsync({ chainId: BSC_CHAIN_ID });
                } catch (error) {
                  console.error("Failed to switch chain:", error);
                  return;
                }
              };
        const response = await checkTokenAllowance({
          owner: connectedAddress,
          spender: process.env.REACT_APP_CHECKOUT_CONTRACT_ADDRESS, // replace with actual spender address
          tokenAddress: process.env.REACT_APP_PAYMENT_TOKEN_ADDRESS, // replace with actual token address
          requiredAmount: MaxUint256.toString(), // you can set this to the maximum uint256 value or calculate based on product price and amount
        });
        if (response.success) {
          setApproved(response.data.isEnough);
        } else {
          console.error("Failed to check token allowance:", response.error);
        }
      };
      checkAllowance();
    }, [connectedAddress, amount]);

  const handleApprove = async () => {
    setIsLoading(true);
    const response = await approveToken({
      tokenAddress: process.env.REACT_APP_PAYMENT_TOKEN_ADDRESS, // replace with actual token address
      spender: process.env.REACT_APP_CHECKOUT_CONTRACT_ADDRESS, // replace with actual spender address
      amount: MaxUint256.toString(), // you can set this to the maximum uint256 value or calculate based on product price and amount
    });
    if (response.success) {
      showToaster({ type: "success", message: "Approval successful!" });
      setApproved(true);
    } else {
      console.error("Failed to approve token:", response.error);
      showToaster({ type: "error", message: "Approval failed. Please try again." });
    }
    setIsLoading(false);
  };

  const calculateSlotCost = (slot) => {
    if (slot < 4 || slot > 24) {
      return 0;
    }

    if (slot >= 4 && slot <= 10) {
      return SLOT_RANGE_PRICES.RANGE_4_10.price;
    }

    if (slot >= 11 && slot <= 15) {
      return SLOT_RANGE_PRICES.RANGE_11_15.price;
    }

    if (slot >= 16 && slot <= 20) {
      return SLOT_RANGE_PRICES.RANGE_16_20.price;
    }

    return SLOT_RANGE_PRICES.RANGE_21_24.price;
  };

  const calculateSlotPrice = (slotCount, currentSlotCount) => {
    let calculatedCost = 0;

    for (let i = 0; i < slotCount; i++) {
      const targetSlot = currentSlotCount + (i + 1);
      const costPerSlot = calculateSlotCost(targetSlot);

      if (!costPerSlot) {
        throw new Error(`Invalid slot range for targetSlot=${targetSlot}`);
      }

      calculatedCost += costPerSlot;
    }

    return Math.floor(calculatedCost);
  };

  useEffect(() => {
    if (!deck?.slotCount) return;
    const calculatedCost = calculateSlotPrice(amount, deck.slotCount);
    setCost(Math.floor(calculatedCost / priceNumber));
  }, [amount, deck?.slotCount, priceNumber]);

  const handleAmountChange = (type) => {
    if (type === "plus") {
      if (deck.slotCount + amount >= 24) return;
      setAmount(amount + 1);
    } else {
      if (amount === 1) return;
      setAmount(amount - 1);
    }
  };
  const handleMax = () => {
    let max = 24 - deck.slotCount;
    setAmount(max);
  };
  const toNano = (amount) => {
    return (Number(amount) * 1e9).toString();
  };

  // if(stage === "confirm"){

  //     return(
  //     <Container>
  //         <FlexContainer flexdirection="column">
  //             <StyledImage src={ConfirmImage} alt="Confirm Image" />
  //             <StyledText2>
  //                 {`You will send ${(cost)} NOVA
  //                 for ${amount} slot`}

  //             </StyledText2>
  //             <StyledText style={{fontSize:"0.8em",fontStyle:"italic",opacity:"0.7"}}>
  //             It will  take some time to processing.
  //             </StyledText>
  //             <PrimaryButton style={{width:"140px",marginBottom:"8px",opacity:buttonIsActive  ? 1 : 0.3}} >Confirm</PrimaryButton>
  //         </FlexContainer>
  //         {transaction && <StyledText2>Invoice ID: {transaction.invoiceId}</StyledText2>}
  //         <StyledText2>Deposit Address: {maskedAddress}</StyledText2>
  //     </Container>
  //     )
  // }

  // if(stage === "prosessing"){
  //     return (
  //         <Container>
  //             <FlexContainer flexdirection="column">
  //                 <StyledImage src={ProsessingImage} alt="Confirm Image" />
  //                 <StyledText>
  //                     Prosessing...
  //                 </StyledText>
  //             </FlexContainer>
  //         </Container>
  //     );

  // }
  // if(stage === "prosessed"){
  //     return (
  //         <Container>
  //             <FlexContainer flexdirection="column">
  //                 <StyledImage src={ProsessedImage} alt="Confirm Image" />
  //                 <StyledText>
  //                     Prosessed...
  //                 </StyledText>
  //                 <PrimaryButton style={{width:"140px",marginBottom:"8px",opacity:buttonIsActive ? 1 : 0.3}}>Close</PrimaryButton>
  //             </FlexContainer>
  //         </Container>
  //     );
  // }
const prepareBasket = () => {
    let basket = [];
    let bulkData = [];
    const currentSlotCount = deck.slotCount;
    for(let i = 0; i < amount; i++){
     const targetSlot = currentSlotCount + (i + 1);
     let item = null;
     if(targetSlot >= 4 && targetSlot <= 10){
        item = {
            productId: SLOT_RANGE_PRICES.RANGE_4_10.productId,
            productName: SLOT_RANGE_PRICES.RANGE_4_10.productName,
            productImage: SLOT_RANGE_PRICES.RANGE_4_10.productImage,
            quantity: 1
        }
     }
    if (targetSlot >= 11 && targetSlot <= 15) {
        item = {
            productId: SLOT_RANGE_PRICES.RANGE_11_15.productId,
            productName: SLOT_RANGE_PRICES.RANGE_11_15.productName,
            productImage: SLOT_RANGE_PRICES.RANGE_11_15.productImage,
            quantity: 1
        }
    }
    if (targetSlot >= 16 && targetSlot <= 20) {
        item = {
            productId: SLOT_RANGE_PRICES.RANGE_16_20.productId,
            productName: SLOT_RANGE_PRICES.RANGE_16_20.productName,
            productImage: SLOT_RANGE_PRICES.RANGE_16_20.productImage,
            quantity: 1
        }
    }
    if (targetSlot >= 21 && targetSlot <= 24) {
        item = {
            productId: SLOT_RANGE_PRICES.RANGE_21_24.productId,
            productName: SLOT_RANGE_PRICES.RANGE_21_24.productName,
            productImage: SLOT_RANGE_PRICES.RANGE_21_24.productImage,
            quantity: 1
        }
    }
    const existingItemIndex = basket.findIndex((b) => b.productId === item.productId);
    if (existingItemIndex !== -1) {
        basket[existingItemIndex].quantity += 1;
    } else {
        basket.push(item);
    }
    }
    return basket;

}
const handleBuy = async () => {
  if(cost > balanceNumber){
    onClose();
    showToaster({message: "Insufficient balance. Please top up your wallet.", type: "error"});
    return;
  }
  if(amount <= 0){
    onClose();
    showToaster({message: "Amount must be at least 1", type: "error"});
    return;
   }
   if(deck.slotCount + amount > 24){
    onClose();
    showToaster({message: "You can't buy more than 24 slots", type: "error"});
    return;
   }
   try {
    setIsLoading(true);
    const basket = prepareBasket();

    const transactionResponse = await createCheckOutTransaction({ basket });
    if(!transactionResponse.success){
      showToaster({message: transactionResponse.error || "Failed to create transaction. Please try again.", type: "error"});
      onClose();
      return;
    }
    const { signature,quote } = transactionResponse.data;
    const buyResponse = await buyCartWithQuote({ quote, signature,items:basket });
    if(!buyResponse.success){
      showToaster({message: buyResponse.error || "Failed to process purchase. Please try again.", type: "error"});
      onClose();
      return;
    }
    showToaster({message: "Purchase successful! Your slots will be added shortly.", type: "success"});
    navigate("/orders");
    onClose();
   } catch (error) {
    console.error("Purchase error:", error);
    showToaster({message: "An error occurred during purchase. Please try again.", type: "error"});
    onClose();
   }finally{
    setIsLoading(false);
   }
}
  return (
    <FlexContainer flexdirection="column">
      <StyledText>Available Slot: {deck.slotCount}/24</StyledText>
      <IconButtonContainer>
        <StyledIconButton onClick={() => handleAmountChange("minus")}>
          <StyledIcon src={MinusIcon} alt="Minus Icon" />
        </StyledIconButton>
        <MiddleContainer>{amount}</MiddleContainer>
        <StyledIconButton onClick={() => handleAmountChange("plus")}>
          <StyledIcon src={PlusIcon} alt="Plus Icon" />
        </StyledIconButton>
      </IconButtonContainer>
      <StyledBuyButton onClick={handleMax}>Max</StyledBuyButton>
      <CostContainer>
        <span>Cost:</span>
        <img src={NovaIcon} alt="Nova Icon" />
        <span>{cost.toLocaleString(undefined, { maximumFractionDigits: 2 })} NOVA</span>
      </CostContainer>
      <PrimaryButton onClick={approved ? handleBuy : handleApprove} style={{ width: "120px" }}>{approved ? "Buy" : "Approve"}</PrimaryButton>
      <StyledText>
        Wallet Balance:{" "}
        {isLoading ? "Loading..." : Number(balanceNumber).toLocaleString(undefined, {
          maximumFractionDigits: 2,
        }) || 0}
      </StyledText>
    </FlexContainer>
  );
};

const StyledIcon = styled.img`
  width: calc(4 * var(--vw));
`;
const StyledIconButton = styled(IconButton)`
  background: linear-gradient(
    180deg,
    #9939ad 12.44%,
    #40297c 45.28%,
    #250964 50.97%,
    #582063 100%
  );
  border: none;
  box-shadow: 0px 0.74px 7.41px 0px #00000033;
  max-width: 67px;
`;
const IconButtonContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 10px;
  margin-top: 16px;
`;
const MiddleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  background: #63636333;
  border-radius: 100px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  width: 150px;
  height: 42px;
`;
const StyledBuyButton = styled.button`
  border: 1px solid #ffffff;
  outline: none;
  color: white;
  background: transparent;
  border-radius: 100px;
  height: 32px;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledText = styled.span`
  font-size: 0.8em;
  font-weight: 400;
  font-weight: 600;
  color: #ffffff;
  margin: 16px 0;
`;
const CostContainer = styled(FlexContainer)`
  height: 100%;
  margin-top: 16px;
  gap: 8px;
  img {
    width: 32px;
  }
`;
const Container = styled.div`
  width: 100%;
  padding: 0 16px;
  padding-bottom: 34px;
`;

const StyledImage = styled.img`
  /* width: 100%; */
  width: 100%;
  max-width: 88px;
  animation: ${hearthbeat} 1.5s ease-in-out infinite both;
`;
const StyledText2 = styled.p`
  font-size: 1.2rem;
  text-align: center;
  margin-top: 2vh;
`;
export default BuySlotModalContent;
